export default __webpack_public_path__ + "static/media/sticker-C.23e3a450.png";